import { render } from "./ResultsList.vue?vue&type=template&id=5743f3fc"
import script from "./ResultsList.vue?vue&type=script&lang=js"
export * from "./ResultsList.vue?vue&type=script&lang=js"

import "./ResultsList.vue?vue&type=style&index=0&id=5743f3fc&lang=scss"
script.render = render

export default script